<template>
	<v-dialog v-model="showDialog" max-width="400" persistent>
		<v-card>
			<v-card-title>{{ dialogOptions.title }}</v-card-title>
			
			<v-divider></v-divider>
			
			<v-card-text class="pa-6">
				<v-alert
					:type="dialogOptions.type"
					variant="tonal"
				>
					<div class="text-body-1">
						{{ dialogOptions.message }}
					</div>
				</v-alert>
			</v-card-text>
			
			<v-divider></v-divider>
			
			<v-card-actions class="pa-4">
				<v-spacer></v-spacer>
				<v-btn @click="handleCancel" variant="outlined" class="btn-legacy-cancel">
					{{ dialogOptions.cancelText }}
				</v-btn>
				<v-btn
					@click="handleConfirm"
					:color="confirmButtonColor"
					class="ml-2 btn-legacy-save"
				>
					{{ dialogOptions.confirmText }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useConfirm } from '@/composables/useConfirm'

const { showDialog, dialogOptions, handleConfirm, handleCancel } = useConfirm()

const confirmButtonColor = computed(() => {
	switch (dialogOptions.value.type) {
		case 'error':   return 'error'
		case 'warning': return 'warning'
		case 'success': return 'success'
		default:        return 'primary'
	}
})
</script>

